import { apiService } from './apiService';
import { getApiErrorMessage } from './tenantDefaultsService';

const CONNECTION = 'backend_py';
const KEYS_PATH = '/api/v1/tenant-defaults/orchestration-keys';

export interface OrchestrationKeysDto {
  configured: boolean;
  apiKeyMasked: string;
  hasSecret: boolean;
  updatedAt?: string | null;
}

export const orchestrationKeysService = {
  get: () => apiService.get(KEYS_PATH, {}, CONNECTION) as Promise<OrchestrationKeysDto>,

  upsert: (apiKey: string, apiSecret: string) =>
    apiService.put(KEYS_PATH, { apiKey, apiSecret }, CONNECTION) as Promise<OrchestrationKeysDto>,

  remove: () => apiService.delete(KEYS_PATH, CONNECTION),
};

export { getApiErrorMessage };
